import React, { useEffect, useRef } from 'react'
import * as S from './styles'

import DetailsMenuButton from './DetailsMenuButton'

import { isValueDefined } from '@/services/functions'

const DetailsMenu = ({ data, indexState, indexHandler }) => {
  const currentIndexRef = useRef()

  useEffect(() => {
    if (!isValueDefined(indexState)) return

    if (isValueDefined(currentIndexRef.current)) {
      const oldDiv = document.getElementById('current_detail_item')
      const oldBtn = document.getElementById(
        `btn_details_${currentIndexRef.current}`
      )
      oldDiv.classList.remove('active')
      oldBtn.classList.remove('selected')
    }

    currentIndexRef.current = indexState

    const newBtn = document.getElementById(`btn_details_${indexState}`)
    newBtn.classList.add('selected')

    setTimeout(() => {
      const newDiv = document.getElementById('current_detail_item')
      newDiv.classList.add('active')
    }, 200)
  }, [indexState])

  return (
    data && (
      <S.DetailsMenuContainer>
        {data.map((detail, i) => (
          <DetailsMenuButton
            key={i}
            index={i}
            data={detail}
            handler={indexHandler}
          />
        ))}
      </S.DetailsMenuContainer>
    )
  )
}

export default DetailsMenu
